import React from 'react';
import { Alert, Button } from '@mui/material';
import { useGetEmployeeById } from '../../services/react-query/employees';
import { AttendanceStatus, Event } from '../../types/Event';
import { _nullishCoalesce } from '@sentry/core';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
import { useUpdateEventAttendance } from '../../services/react-query/events';

interface IAttendanceBannerProps {
  event: Event;
}

export default function AttendanceBanner({ event }: IAttendanceBannerProps) {
  const { data: currentEmployeeData } = useGetEmployeeById({ uuid: 'current' });
  const { uuid } = useParams();
  const { mutate: updateAttendance } = useUpdateEventAttendance({ uuid: uuid ?? '' });

  if (!currentEmployeeData || !uuid) return null;

  const isPending = _.includes(
    _(event.event_employees)
      .filter((ee) => ee.employee.uuid === currentEmployeeData.uuid)
      .map('status')
      .value(),
    AttendanceStatus.PENDING
  );
  if (!isPending) return null;

  return (
    <Alert
      severity="info"
      action={
        <>
          <Button color="success" onClick={() => updateAttendance(AttendanceStatus.ACCEPTED)}>
            Accept
          </Button>
          <Button color="error" onClick={() => updateAttendance(AttendanceStatus.DECLINED)}>
            Decline
          </Button>
        </>
      }
    >
      You have a pending assignment to this event. Please accept or decline.
    </Alert>
  );
}
